import { render, staticRenderFns } from "./regionAdd.vue?vue&type=template&id=29ff3bd0&"
import script from "./regionAdd.vue?vue&type=script&lang=js&"
export * from "./regionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ff3bd0')) {
      api.createRecord('29ff3bd0', component.options)
    } else {
      api.reload('29ff3bd0', component.options)
    }
    module.hot.accept("./regionAdd.vue?vue&type=template&id=29ff3bd0&", function () {
      api.rerender('29ff3bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/region-manage/regionAdd.vue"
export default component.exports